<template>
  <el-dialog :visible.sync="modalIA" @close="close">
      <p>{{ $t('socialPosts.create.modalAI.objectTitle') }}</p>

        <hr>
      <p v-html="$t('socialPosts.create.modalAI.objectSubtitle')">
      </p>
<!--      <el-input v-model="contextIA"></el-input>-->
    <div class="wait-captionIA" v-if="loadingStatusIAGeneration">
      <p>{{ $t('posts.IA.textSpinnerIA') }}</p>
      <div><Stretch /><br><br></div>
    </div>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'initial'"
                v-model="post.initial.iaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'facebook'"
                v-model="post.facebook.iaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'google'"
                v-model="post.google.iaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'instagram'"
                v-model="post.instagram.iaPrompt"></el-input>
      <el-input type="textarea" rows="6"
                v-if="networkClicked === 'linkedin'"
                v-model="post.linkedin.iaPrompt"></el-input>
    <el-row>
      <el-col :lg="24">{{ generatedText }}</el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
              <el-button @click="close">{{ $t('socialPosts.create.modalAI.cancel') }}</el-button>
              <el-button type="primary" @click="generatePostIA()" :disabled="loadingStatusIAGeneration">{{ $t('socialPosts.create.modalAI.generatePost') }}</el-button>
            </span>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Stretch from '@/components/spinners/Stretch'
export default {
  name: 'PostEditoCreateModalIA',
  props: ['post'],
  components: {
    Stretch
  },
  data () {
    return {
      promptIA: '',
      generatedText: '',
      contextIA: ''
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial',
      ['modalIA', 'networkClicked', 'loadingStatusIAGeneration'])
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setModalIA']),
    generatePostIA () {
      this.$store.commit('socialPostsCreationPostEditorial/setLoadingStatusIAGeneration', true)
      const create = this.$store.state.socialPostsCreationPostEditorial.create
      if (create && !this.$store.getters['socialPostsCreationPostEditorial/getId']) {
        if (!this.post.initial.inputText) {
          this.$store.commit('socialPostsCreationPostEditorial/setInitialInputText', this.post.initial.iaPrompt)
        }
        this.$store.dispatch('socialPostsCreationPostEditorial/validatePost', { typePost: 'B', generateIA: true, network: this.networkClicked })
      } else {
        this.$store.dispatch('socialPostsCreationPostEditorial/validatePost', { generateIA: true, network: this.networkClicked })
      }
      this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState')
      this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')
      this.$store.commit('socialPostsCreationPostEditorial/setLoadingStatusIAGeneration', false)
    },
    confirm () {
      this.setModalIA(false)
    },
    close () {
      this.setModalIA(false)
    }
  }
}
</script>

<style scoped>
.wait-captionIA {
  width: 100%;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wait-captionIA p {
  width: 350px;
  font-weight: 600;
  color: #0ab1bf;
}
</style>
